import type {} from '@qunhe/egs-typings';
export * from './src/EGS';
import * as EGS from './src/EGS';
export default EGS;

window.EGS_MODULE_INITIALIZED = true;
